import { connect } from 'react-redux';
import AdminReports from '../../components/AdminReports';
import {
  actions as AdminReportsActions,
  selectors as AdminReportsSelector,
} from '../../reducers/adminReports';

const mapStateToProps = (state) => {
  const adminReports = AdminReportsSelector.getAdminReportsUrl(state);

  return {
    adminReports,
    isLoading: state.adminReports.isLoading,
  };
};

const mapDispatchToProps = {
  fetchAdminReportsUrl: AdminReportsActions.fetchAdminReportsUrl,
};

export default connect(mapStateToProps, mapDispatchToProps)(AdminReports);
